import { AddComment, HighlightOffRounded } from "@mui/icons-material";
import { IconButton, Stack, TextField, Tooltip } from "@mui/material";
import SaveButton from "components/Buttons/SaveButton";
import { useEffect, useState } from "react";
import { standardBorder } from "theme/base/borders";

interface Props {
  onSave: (note: string) => void;
}
export default function NewNote(props: Props) {
  const [value, setValue] = useState("");
  const [addMode, setAddMode] = useState(false);
  useEffect(() => setValue(""), [addMode]);

  return addMode ? (
    <Stack
      spacing={2}
      sx={{
        ...standardBorder,
        position: "relative",
        p: "2rem 1rem 1rem 1rem",
        alignItems: "center",
        backgroundColor: "rgba(0,0,0,.05)",
      }}
    >
      <IconButton
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
        }}
        onClick={() => setAddMode(false)}
      >
        <HighlightOffRounded />
      </IconButton>
      <TextField
        placeholder="Add a note..."
        multiline
        rows={4}
        value={value}
        onChange={(event) => setValue(event.target.value)}
      />
      <SaveButton
        disabled={!value}
        onClick={() => {
          setAddMode(false);
          props.onSave(value);
        }}
        sx={{ width: "10rem" }}
      >
        Save New Note
      </SaveButton>
    </Stack>
  ) : (
    <Stack sx={{ alignItems: "center" }}>
      <Tooltip title="Add a Note" placement="right">
        <IconButton onClick={() => setAddMode(true)}>
          <AddComment />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
